import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Oluwaseun from "../../../assets/judges/oluwaseun.jpg";
import Ayo from "../../../assets/judges/obe.jpg";
import Oreoluwa from "../../../assets/judges/oreoluwa.jpg";
import Joseph from "../../../assets/judges/joseph.jpg";

const ourJudges = [
  {
    name: "Oluwaseun Ayodeji Osowobi",
    profile:
      " Oluwaseun Ayodeji Osowobi is a multi-award-winning global gender equality advocate with experience in deploying solutions to challenge social barriers that promote sexual and gender-based violence against women and girls and utilising social and behaviour change communication to improve attitudes and practices to foster gender equality. She collaborates with and scales the capacity of state and non-state actors to implement policies and programs that advance women’s rights and safety.",
    profile2:
      "Oluwaseun is the Executive Director of Stand to End Rape Initiative (STER), 2020 Global Citizen Nigeria Hero, a UN Young Leader for the Sustainable Development Goals (SDGs), and TIME 100 NEXT Honouree.",
    imgpath: Oluwaseun,
  },
  {
    name: "Oreoluwa Lesi",
    profile:
      "Oreoluwa Lesi is the Founder and Executive Director of the Women’s Technology Empowerment Centre (W.TEC), a nonprofit committed to building a more inclusive technology ecosystem with the next generation of women technology creators, entrepreneurs and leaders. She has designed high-quality programming for over 31,000 girls and women - many of whom have been inspired to pursue science, engineering or technology careers.",
    profile2:
      "She is a Vital Voices Lead Fellow (awarded to emerging and established women leaders across the world), Ashoka fellow (a network of the world’s leading social entrepreneurs) and a recipient of the Anita Borg Change Agent Award (for her commitment to supporting women in computing in Nigeria).",
    imgpath: Oreoluwa,
  },
  {
    name: "Mrs Ayo Obe",
    profile:
      "Ayo Obe (née Ogunsola) is a legal practitioner and a partner, with Olasupo Shonibare, in the Lagos-based law firm, Ogunsola Shonibare. She is a Trustee of Senegal’s Gorée Institute and of the Brussels-based International Crisis Group.  In Nigeria, she is on the board of the Z.O. Dibiaezue Memorial Libraries and is an active member of the #BringBackOurGirls campaign.",
    profile2:
      "A former President of the Civil Liberties Organisation, Mrs Obe was also chair of the Transition Monitoring Group, the Steering Committee of the World Movement for Democracy and the Nigerian Civil Society’s panel on Police Reform in Nigeria. Mrs Obe currently hosts IDEAs, a radio programme on integrity, ethics and accountability in democracy on Nigeria Info 97.3FM.",
    imgpath: Ayo,
  },
  {
    name: "Joseph Amenaghawon",
    profile:
      "Joseph Idahosa Amenaghawon is the Strategy and Growth Advisor at BudgiT Foundation. In the last twelve years, he served as the Economic Governance/ Justice Coordinator at the Open Society Initiative for West Africa (OSIWA), where he was actively involved in supporting strategy design and implementation, grant making and grantees supervision, project management, monitoring, evaluation and learning.",
    profile2:
      " Joseph is currently a Doctorate candidate in Development Studies at Atlantic International University. He holds a master’s degree in international law and Diplomacy (MILD) and a bachelor’s degree in Economics.  He has also attended several professional and leadership training courses, including the prestigious Harvard Kennedy School.",
    imgpath: Joseph,
  },
];

const JudgesList = () => {
  return (
    <Grid item xs={12} md={12}>
      <Typography
        variant={"body1"}
        fontWeight={500}
        textAlign={"left"}
        padding={{ xs: "0% 0% 10% 0%", sm: "1% 0%" }}
        color={"#4f4f4f"}
        lineHeight={"1.625em"}
      >
        The Active Citizens Awards are judged by an esteemed panel of civic
        leaders and experts. The judging is a rigorous two-stage process
        including pre-scoring to determine shortlists and a judging meeting
        where entries are discussed and evaluated in detail to decide the
        winning nominations.
      </Typography>
      <Grid
        item
        xs={12}
        md={12}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        marginTop={"5%"}
        flexWrap={"wrap"}
      >
        {ourJudges.map((judge, index) => {
          const { name, profile, profile2, imgpath } = judge;
          return (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              marginBottom={{ xs: "7%", sm: "2%" }}
              marginLeft={{ xs: "4%", sm: "2%" }}
            >
              <Card sx={{ maxWidth: 345, height: "100%" }}>
                <CardActionArea>
                  <CardMedia
                    component="img"
                    height="340"
                    image={imgpath}
                    alt={name}
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      color={"#004165"}
                      component="div"
                      paddingBottom={"4%"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      paddingBottom={"5%"}
                      variant="body1"
                      color="text.secondary"
                      data-aos={"fade-up"}
                    >
                      {profile}
                    </Typography>
                    <Typography
                      variant="body1"
                      color="text.secondary"
                      data-aos={"fade-up"}
                    >
                      {profile2}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default JudgesList;
